<script lang="ts">
  import { currentDoc, projectStore, readToMeDocId, settings } from '@dabble/app';
  import { Doc } from '@dabble/data/types';
  import { tick } from 'svelte';
  import NavItem from './NavItem.svelte';

  export let scrolled = false;
  export let visibleNav: Set<string> | null = null;
  let projectChildren: Doc[];
  let scrollContainer: HTMLElement;
  const scrollPadding = 16;

  $: project = $projectStore.project;
  $: projectChildren = (project && projectStore.getChildren(project.id)) || [];
  $: children = (projectChildren && filterChildren(projectChildren)) || [];
  $: if ($currentDoc) onCurrentDocChange();

  function onScroll() {
    scrolled = this.scrollTop > 0;
  }

  function filterChildren(children: Doc[]) {
    const exists = new Set();
    return children.filter(child => {
      if (settings.getFor(child).hideInNavigation || exists.has(child.id)) return false;
      exists.add(child.id);
      return true;
    });
  }

  async function onCurrentDocChange() {
    await tick();
    const selected = scrollContainer.querySelector('.selected > .nav-item-header, .child-selected > .nav-item-header');
    if (selected) {
      $readToMeDocId = $currentDoc?.id;
      scrollIntoViewIfNeeded(scrollContainer, selected);
    }
  }

  function scrollIntoViewIfNeeded(container: Element, element: Element) {
    let rect = element.getBoundingClientRect();
    if (rect) {
      const relative = container.getBoundingClientRect();
      const leftOffset = container.scrollLeft - relative.x;
      const topOffset = container.scrollTop - relative.y;
      rect = new DOMRect(rect.x + leftOffset, rect.y + topOffset, rect.width, rect.height);
    }
    const { scrollTop, clientHeight } = container;
    const scrollBottom = scrollTop + clientHeight;
    const centered = rect.bottom - Math.floor(clientHeight / 2);
    if (rect.top < scrollTop) {
      if (rect.bottom > scrollTop) {
        container.scrollTop = rect.top - scrollPadding;
      } else {
        container.scrollTop = centered;
      }
    } else if (rect.bottom > scrollBottom) {
      if (rect.top < scrollBottom) {
        container.scrollTop = rect.bottom - container.clientHeight + scrollPadding;
      } else {
        container.scrollTop = centered;
      }
    }
  }
</script>

<div on:scroll={onScroll} bind:this={scrollContainer} class="main-nav nav-container">
  {#if project}
    {#if !$settings[project.type].hideInNavigation}
      <NavItem doc={project} {visibleNav} noChildren />
    {/if}
    {#each children as doc (doc.id)}
      <NavItem {doc} {visibleNav} />
    {/each}
    {#if project.docs?.templates && (!visibleNav || visibleNav.templates)}
      <NavItem doc={project.docs.templates} {visibleNav} />
    {/if}
    {#if !visibleNav || visibleNav.trash}
      <NavItem doc={project.docs.trash} {visibleNav} />
    {/if}
  {/if}
</div>

<style>
  .main-nav {
    position: relative;
    flex: 1 1 100%;
    margin-top: 0;
    padding-top: 4px;
    padding-bottom: calc(var(--side-nav-item-height) * 4);
    overflow-y: auto;
    -webkit-overflow-scrolling: auto;
  }
</style>
